import { useContext, useState, useEffect } from 'react';
import { useNavigate, useSearch } from '@tanstack/react-router';

import config from '@/config';
import { Issue } from '@/constants';

import { HomeContext } from '../Home.context';
import {
	AUTH_KEY,
	AuthenticateUserResponse,
} from '../auth/Authentication.hooks';

export function useIsSupportMagazine(): null | boolean {
	const [isSupported, setIsSupported] = useState<null | boolean>(null);

	useEffect(() => {
		if (!config.app.auth.enabled) {
			setIsSupported(true);
			return;
		}

		if (
			config.app.auth.type === 'token' ||
			config.app.auth.type === 'cognito'
		) {
			setTimeout(() => {
				if (localStorage.getItem(AUTH_KEY)) {
					setIsSupported(true);
				} else {
					setIsSupported(false);
				}
			}, 1000);
			return;
		}

		if (!localStorage.getItem('authenticated')) {
			return;
		}
		const userString = localStorage.getItem('user');
		if (userString === null) {
			window.location.href = '/';
			return;
		}
		const user: AuthenticateUserResponse = JSON.parse(userString);
		setIsSupported(user?.digitalAccess);
	}, []);
	return isSupported;
}

export function useSelectIssue(issues: Array<Issue>) {
	const navigate = useNavigate();
	const search = useSearch({ strict: false });
	const { setSelectedIssue } = useContext(HomeContext);
	useEffect(() => {
		if (!issues.length) {
			return;
		}
		const section = 'magazines';

		const id = search.id;
		if (!id) {
			navigate({
				to: '/',
				search: (prev: any) => ({
					...prev,
					section,
				}),
			});
			return;
		}

		const filteredIssue = issues
			.filter(issue => `${issue.id}` === `${id}`)
			.pop();

		if (filteredIssue) {
			setSelectedIssue(filteredIssue);
			navigate({
				to: '/',
				search: (prev: any) => ({
					...prev,
					id: filteredIssue.id,
				}),
			});
			return;
		}

		setSelectedIssue(null);
		navigate({
			to: '/',
			search: (prev: any) => ({
				...prev,
				id: '',
			}),
		});
	}, [search, issues]);
}
